const SPA_TEMPLATES = {
  standard: "standard",
  card: "card",
  clean: "clean",
  banner: "standard",
  cocoon: "card",
};

/** Maps a provider's template key to the SPA template that renders it, defaulting to standard. */
export const templateKey = provider => SPA_TEMPLATES[(provider || {}).template] || "standard";

const HEX_COLOR = /^#[0-9a-f]{6}$/i;

/** Applies the settings preview's unsaved template and brand color from the URL params without saving them. */
export const previewProvider = (provider, params) => ({
  ...provider,
  ...(params.template && { template: params.template }),
  ...(HEX_COLOR.test(params.brand_color) && { backgroundColor: params.brand_color }),
});
